<template lang="pug">

  div

    v-dialog(v-model="showPayrollModal" max-width="280px" :persistent="loading === true")

      .dialogHeader

        .dialogHeaderTitle
          | Folha de pagamento

        .dialogHeaderClose
          .dialogCloseButton.mdi.mdi-close(@click="closePayrollModal()")

      .dialogBody

        .dialogBodyContent

          .payrollField.payrollField--no__margin.payrollField--first
            label.csLabel
              span(v-html="'Período'")
            .csFields.csFields--date
              date-picker(v-model="dateRange" :clearable="false" :disabled-date="disableDatesCondition" range valueType="format" format="DD/MM/YYYY" :lang="lang" class="groupUserField--date" :disabled="loading")

          .payrollField.payrollField--last
            label.csLabel
              span(v-html="'Opções'")
            .csFields.csFields--date
              div
                sos-checkbox(id="resumido" label="Relatório resumido" :checked="isSummaryReport" :disabled="comPonto" @click="onSummaryReportSettingClick" class="sosCheckbox--payroll")
              div
                sos-checkbox(id="ponto" label="Incluir registros de ponto?" :checked="comPonto" :disabled="isSummaryReport" @click="onComPontoSettingClick" class="sosCheckbox--payroll")

          .mt-5.text-right
            sos-button(@buttonClick="generate()" color="blue" buttonIcon="mdi-file-document-plus" buttonLabel="Gerar relatório" buttonIconSize="18" size="medium" :loading="loading")

    //- DIALOG PARA CONFIRMAÇÃO OU INFORMAÇÃO
    confirm-dialog(ref="cdConfirmModal" :title="cdParameters.title" :text="cdParameters.text" :buttonPosition="cdParameters.buttonPosition" :width="cdParameters.width" @close="cdMessageResponse")

    //- DIALOG PARA INFORMAR LIMITAÇÃO DE FUNCIONALIDADE E SITUAÇÃO DO PLANO ATUAL
    subscription-modal(:active="subscriptionModal.active" :titulo="subscriptionModal.title" :text="subscriptionModal.message" @close="closeSubscriptionModal")

</template>

<script>

  //
  // NOTES:
  // Limpar da memória
  //

  import { mapState } from 'vuex'

  import { freeVersion } from '@/constants'
  import { apiCheckReportStatus, apiOpenReport } from '@/services/report'

  import { formatDate, isValidDate, parseDate } from '@/mixins/utils.js'

  import SubscriptionModalMixin from '@/mixins/subscription.modal.mixin'
  import confirmDialogMixin from '@/mixins/cd.mixin.js'

  import SosButton from '@/components/SosButton'
  import SosCheckbox from '@/components/SosCheckbox'

  import SubscriptionModal from '@/modals/SubscriptionModal'
  import ConfirmDialog from '@/modals/ConfirmDialog'

  import DatePicker from 'vue2-datepicker'
  import 'vue2-datepicker/index.css'

  import moment from 'moment'
  import 'moment/locale/pt-br'

  moment.locale('pt-BR')

  //
  //
  //

  export default {
    name: 'RelatorioFolhaPagamento',

    components: {
      SubscriptionModal,
      'sos-button': SosButton,
      'confirm-dialog': ConfirmDialog,
      'date-picker': DatePicker,
      'sos-checkbox': SosCheckbox,
    },

    mixins: [
      SubscriptionModalMixin,
      confirmDialogMixin,
    ],

    data () {
      return {
        // DIALOG VISIBILITY
        showPayrollModal: false,

        // IS BUILDING THE REPORT?
        loading: false,

        // DATE RANGE
        dateRange: null,

        // RELATÓRIO RESUMIDO?
        isSummaryReport: false,

        // RELATÓRIO COM REGISTROS DE PONTO?
        comPonto: false,

        // DATE PICKER SETTING
        lang: {
          formatLocale: {
            // MMMM
            months: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
            // MMM
            monthsShort: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
            // dddd
            weekdays: ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'],
            // ddd
            weekdaysShort: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sab'],
            // dd
            weekdaysMin: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sab'],
            // weekdaysMin: ['Do', 'Se', 'Te', 'Qu', 'Qu', 'Se', 'Sa'],
          },
          yearFormat: 'YYYY',
          monthFormat: 'MMMM',
        },
      }
    },

    computed: {
      ...mapState(['userSession']),
    },

    /* watch: {
      dateRange: {
        immediate: true,
        handler (newRange, oldRange) {
          // [24/01/25] console.log('::: WATCHING DATE RANGE:', oldRange, newRange)
        },
      },
    }, */

    methods: {
      //
      //
      //
      // DESABILITA TODAS AS DATAS ANTERIORES A 2016
      // CONSIDERAR FUSO HORÁRIO?
      //
      //
      //

      disableDatesCondition (date, currentValue) {
        return date < new Date(2016, 0, 1)
      },

      //
      //
      //
      // OPEN MODAL
      //
      //
      //

      async open (month = 'NO', year = 'NO')
      {
        // [24/01/25] console.log('::: RELATÓRIO FOLHA DE PAGAMENTO:', month, year)

        if (this.loading) return false

        //
        // SHOW MODAL
        //

        this.showPayrollModal = true

        //
        // SET THE CURRENT RANGE BASED IN THE SELECTED MONTH/YEAR AT THE PREVIOUS SCREEN
        //

        if (year !== 'NO' && month !== 'NO')
        {
          // Get the first day of the current month
          var firstDay = new Date(year, month, 1)
          // Get the last day of the current month
          var lastDay = new Date(year, month + 1, 0)

          // Format and output the first and last day
          this.dateRange = [formatDate(firstDay), formatDate(lastDay)]
        }
        else
        {
          // Initialize Moment JS
          moment.locale('pt-BR')

          // Aplica mês e ano vigentes
          this.dateRange = [
            moment().startOf('month').format('DD/MM/YYYY'),
            moment().endOf('month').format('DD/MM/YYYY'),
          ]
        }
      },

      //
      //
      //
      // CLOSE MODAL
      //
      //
      //

      closePayrollModal ()
      {
        if (!this.loading) this.showPayrollModal = false
      },

      //
      //
      //
      // ON "IS SUMMARY REPORT" CHECKBOX CLICK
      //
      //
      //

      onSummaryReportSettingClick ()
      {
        this.isSummaryReport = !this.isSummaryReport

        if (this.isSummaryReport) this.comPonto = false
      },

      //
      //
      //
      // ON "COM PONTO" CHECKBOX CLICK
      //
      //
      //

      onComPontoSettingClick ()
      {
        this.comPonto = !this.comPonto

        if (this.comPonto) this.isSummaryReport = false
      },

      //
      //
      //
      // GENERATE REPORT
      //
      //
      //

      async generate ()
      {
        //
        // PREVENNT MULTIPLE CLICKS DURING LOADING
        //

        if (this.loading) return

        //
        // TRATA USUÁRIO SEM PERMISSÃO
        //

        if (freeVersion === false && this.userSession.userCapabilities.folhaPagamento !== true)
        {
          const planName = this.userSession.planName.name

          const talkToOurSupport = `<a href="https://api.whatsapp.com/send?phone=5513992061010&text=Olá, estou no ${planName} e não consigo gerar a folha de pagamento. Preciso de ajuda." target="_blank">suporte</a>`
          const textSupport = `<p>Por favor, verifique a situação do seu plano com o nosso ${talkToOurSupport}.</p>`

          if (this.userSession.planOrigin === 'CUSTOM') {
            // Plano personalizado
            this.openSubscriptionModal('Verifique seu plano', `<p>Você está no ${planName} personalizado, mas a folha de pagamento não está liberada.</p>${textSupport}`)
          } else if (this.userSession.planOrigin === 'COUPON') {
            // Cupom ativo
            this.openSubscriptionModal('Verifique seu plano', `<p>Você tem um cupom ativo e está no ${planName}, mas a folha de pagamento não está liberada.</p>${textSupport}`)
          } else if (this.userSession.planOrigin === 'VINDI' && this.userSession.vindi.paymentStatus === 'paid') {
            // Assinatura ativa na vindi
            this.openSubscriptionModal('Faça um upgrade', `<p>Você está no ${planName}.</p><p>Para gerar a folha de pagamento, assine o Plano Bronze ou superior.</p><p>Para mais informações, converse o nosso ${talkToOurSupport}.</p>`)
          } else if (this.userSession.planOrigin === 'VINDI' && this.userSession.vindi.paymentStatus !== 'paid') {
            // Assinatura ativa, mas com alguma pendência ou erro na vindi
            this.openSubscriptionModal('Verifique sua assinatura', `<p>Você é assinante do ${planName}, mas ele não está ativo e a folha de pagamento não está liberada.</p>${textSupport}`)
          } else {
            if (!!this.userSession.vindi === true) {
              // Plano da vindi expirado
              this.openSubscriptionModal('Verifique sua assinatura', `<p>Você assinou o ${this.userSession.vindi.planName.name}, mas ele expirou.</p><p>Agora você está no ${planName} e a folha de pagamento não está liberada.</p>${textSupport}`)
            } else {
              // Plano gratuíto ou alcançou alguma condição desconhecida
              this.openSubscriptionModal('Verifique seu plano', `<p>Você está no ${planName} e a folha de pagamento não está liberada.</p>${textSupport}`)
            }
          }

          return false
        }

        //
        // VALIDATE DATE RANGE
        //

        const isItValid = Array.isArray(this.dateRange) && this.dateRange.length === 2 && isValidDate(this.dateRange[0]) && isValidDate(this.dateRange[1])

        if (!isItValid) {
          this.showMessage('Atenção!', 'Selecione o período da folha de pagamento')
          return false
        }

        //
        // VALIDATE DATE RANGE SIZE
        //

        const firstDateObj = parseDate(this.dateRange[0])
        const lastDateObject = parseDate(this.dateRange[1])
        const differenceInDays = Math.floor((lastDateObject - firstDateObj) / (1000 * 60 * 60 * 24))

        if (differenceInDays > 62) {
          this.showMessage('Atenção!', 'Você pode selecionar até dois meses')
          // this.showMessage('Atenção!', 'Você pode selecionar até dois meses para gerar uma folha de pagamento')
          return false
        }

        if (this.isSummaryReport && this.comPonto) {
          this.showMessage('Atenção!', 'Não é possível gerar um relatório resumido com registros de ponto. Escolha apenas uma das opções.')
          return false
        }

        //
        // INITIALIZE VARS
        //

        const { scaleID, groupID } = this.$route.params

        const checkOperationName = scaleID ? 'checkpayroll' : 'checkgrouppayroll'
        const operationName = this.isSummaryReport ? (scaleID ? 'payrollsummary' : 'grouppayrollsummary') : (scaleID ? 'payroll' : 'grouppayroll')
        const hasScale = scaleID ? `${scaleID}/` : ''
        const comPonto = this.isSummaryReport ? '' : (this.comPonto ? '/true' : '/false')

        //
        // MAKE A BACK-END REQUEST FOR GENERATE THIS REPORT
        //

        this.$emit('setButtonState', true)
        this.loading = true

        try
        {
          const checkEndpoint = `${checkOperationName}/${groupID}/${hasScale}${this.dateRange[0]}/${this.dateRange[1]}`
          const generateUrl = `${operationName}/${groupID}/${hasScale}${this.dateRange[0]}/${this.dateRange[1]}${comPonto}`

          const response = await apiCheckReportStatus(checkEndpoint)

          if (response.code !== 1) {
            this.showMessage(response.title, response.message)
          } else {
            apiOpenReport(generateUrl)
          }
        }
        catch (error)
        {
          this.showMessage('Erro!', 'Não foi possível gerar o relatório. Por favor, atualize a página e tente novamente ou fale com o nosso suporte.')
        }

        this.loading = false
        this.$emit('setButtonState', false)
      },
    },
  }

</script>

<style lang="scss" scoped>

  .groupUserField--date {
    width: 100%;
  }

</style>

<style lang="scss">

  .sosCheckbox--payroll.sosCheckbox .sosCheckboxLabel {
    padding-left: 7px;
    font-size: 15px;
  }

</style>
